<template>
  <div class="card">
    <div class="card-body">
      <cui-invoice/>
    </div>
  </div>
</template>

<script>
import CuiInvoice from '@/components/CleanUIComponents/Invoice'

export default {
  components: {
    CuiInvoice,
  },
}
</script>
